import { createSlice } from '@reduxjs/toolkit';
import { initialState } from '../../../data/entitlement/outOfScopeCases/initialState.outOfScopeCases.data';
import { ERROR_MESSAGE } from '../../../constants';
import {
  fetchAccountingGroupsData as fetchAccountingGroupsAPI,
  byMultipleInputs as byMultipleInputsAPI,
  fetchSummaryData as fetchSummaryDataAPI,
  fetchCaseId as fetchCaseIdAPI,
  fetchNotes as fethcNotesAPI,
  fetchCaseDetails as fetchCaseDetailsAPI,
  fetchCaseSiteDetails as fetchCaseSiteDetailsAPI,
  fetchOOSCaseItems as fetchOOSCaseItemsAPI,
  fetchOOSCaseItemHistory as fetchOOSCaseItemHistoryAPI,
  fetchOOSCaseItemComment as fetchOOSCaseItemCommentAPI,
  fetchOOSCaseItemRMA as fetchOOSCaseItemRMAAPI,
  saveOOSCaseItems as saveOOSCaseItemsAPI,
} from '../../../apis/outOfScopeCasesAPI';
import { ACTIONS_OOS_CASES } from '../../../constants/actionCreator';
import { createAsyncThunkWrapper } from '../../../services/common/asyncThunkWrapper';

export const fetchAccountingGroups = createAsyncThunkWrapper(
  ACTIONS_OOS_CASES.FETCH_ACCOUNTING_GROUPS,
  fetchAccountingGroupsAPI
);

export const getSearchByMultipleInputs = createAsyncThunkWrapper(
  ACTIONS_OOS_CASES.SEARCH_ALL_CUSTOMERS_BY_MULTIPLE_INPUTS,
  byMultipleInputsAPI
);

export const getHandelSummary = createAsyncThunkWrapper(
  ACTIONS_OOS_CASES.GET_SUMMERY,
  fetchSummaryDataAPI
);

export const getHandleCaseId = createAsyncThunkWrapper(
  ACTIONS_OOS_CASES.GET_CASE_ID,
  fetchCaseIdAPI
);

export const getOosNotes = createAsyncThunkWrapper(
  ACTIONS_OOS_CASES.GET_NOTES,
  fethcNotesAPI
);

export const getHandleCaseDetails = createAsyncThunkWrapper(
  ACTIONS_OOS_CASES.GET_CASE_DETAILS,
  fetchCaseDetailsAPI
);

export const getHandleCaseSiteDetails = createAsyncThunkWrapper(
  ACTIONS_OOS_CASES.GET_CASE_SITE_DETAILS,
  fetchCaseSiteDetailsAPI
);

export const getHandleOOSCaseItems = createAsyncThunkWrapper(
  ACTIONS_OOS_CASES.GET_OOS_CASE_ITEMS,
  fetchOOSCaseItemsAPI
);

export const getHandleOOSCaseItemHistory = createAsyncThunkWrapper(
  ACTIONS_OOS_CASES.GET_OOS_CASE_ITEM_HISTORY,
  fetchOOSCaseItemHistoryAPI
);

export const getHandleOOSCaseItemComment = createAsyncThunkWrapper(
  ACTIONS_OOS_CASES.GET_OOS_CASE_ITEM_COMMENT,
  fetchOOSCaseItemCommentAPI
);

export const getHandleOOSCaseItemRMA = createAsyncThunkWrapper(
  ACTIONS_OOS_CASES.GET_OOS_CASE_ITEM_RMA,
  fetchOOSCaseItemRMAAPI
);

export const saveHandleOOSCaseItems = createAsyncThunkWrapper(
  ACTIONS_OOS_CASES.SAVE_OOS_CASE_ITEMS,
  saveOOSCaseItemsAPI
);

const CustomersSearchSlice = createSlice({
  name: 'outOfScopeCases',
  initialState,
  reducers: {
    resetValues: () => initialState,

    resetBackValues: (state) => {
      state.oosCaseItems = initialState.oosCaseItems;
      state.caseDetails = initialState.caseDetails;
      state.caseSiteDetails = initialState.caseSiteDetails;
      state.caseId = initialState.caseId;
      state.fastFindData = initialState.fastFindData;
      state.saveMessage = initialState.saveMessage;
      state.itemIndex = initialState.itemIndex;
      state.chargeIndex = initialState.chargeIndex;
    },
    formResetValues: (state) => {
      state.oosCasesmultipleInputsValue =
        initialState.oosCasesmultipleInputsValue;
      state.singleFieldSearch = initialState.singleFieldSearch;
      state.caseId = initialState.caseId;
      state.searchResult = initialState.searchResult;
      state.oosCasesLoading = false;
      state.oosCasesTotalRecords = 0;
      state.summaryData = initialState.summaryData;
    },
    setSelectedComponent: (state, action) => {
      state.selectedComponent = action?.payload;
    },

    setSelectedAccountGridRowsData: (state, action) => {
      state.accountingGroupModal.gridAccountingRowSelectedData =
        action?.payload;
      state.accountingGroupModal.gridAccountingRowSelectedCount =
        action?.payload?.length;

      state.oosCasesmultipleInputsValue.accountingGroupCode = action?.payload[0]
        ?.accountingGroupCode
        ? action?.payload[0].accountingGroupCode
        : '';
    },
    setAccountingGroupModalOpen: (state) => {
      state.accountingGroupModal.openAccountingGroupModal = true;
      state.accountingGroupModal.accountingGroupSearchForm =
        initialState.accountingGroupModal.accountingGroupSearchForm;
    },
    setAccountingGroupModalClose: (state) => {
      state.accountingGroupModal.openAccountingGroupModal = false;
      state.accountingGroupModal.accountingGroupSearchForm =
        initialState.accountingGroupModal.accountingGroupSearchForm;
      state.accountingGroupModal.accountingGroupSearchData =
        initialState.accountingGroupModal.accountingGroupSearchData;
    },

    setAccouningGroupFormFeilds: (state, action) => {
      state.accountingGroupModal.accountingGroupSearchForm[
        action?.payload?.name
      ] = action?.payload?.value;
    },

    setSelectedTabValue: (state, action) => {
      state.selectedTabValue = action?.payload;
    },

    setSaveMultipleValues: (state, action) => {
      state.oosCasesmultipleInputsValue = action?.payload;
    },

    setSaveSingleFieldSearch: (state, action) => {
      state.singleFieldSearch = action?.payload;
    },
    setHandleCaseId: (state, action) => {
      state.caseId = action?.payload;
    },
    setHandleDisplayError: (state, action) => {
      state.displayError = action?.payload;
      state.errorModal = 'enterValue';
    },
    setFastFind: (state, action) => {
      state.fastFindData = action?.payload;
    },

    handleSetChargeCode: (state, action) => {
      state.oosChargeCode = action?.payload;
    },

    handleSelectedOOSItemRow: (state, action) => {
      state.oosSlectedItemRow = action?.payload;
    },

    handelSetClickedIndex: (state, action) => {
      state.itemIndex = action?.payload?.pIndex;
      state.chargeIndex = action?.payload?.chargeIndex;
    },

    handleSetDataToSave: (state, action) => {
      const mydata = JSON.parse(JSON.stringify(state.oosCaseItemsDataToSave));
      state.oosCaseItemsDataToSave = mydata?.map((item, pIndex) => {
        if (state.itemIndex === pIndex) {
          item.chargeCodeList?.map((el, i) => {
            if (
              el.outScopeId === state.oosSlectedItemRow?.outScopeId &&
              el.swCaseId === state.oosSlectedItemRow?.swCaseId
            ) {
              if (state.chargeIndex === i) {
                el['isUpdated'] = true;
              }
              if (action?.payload?.name === 'comment') {
                if (el.oosItemsComment) {
                  el.oosItemsComment['comment'] = action?.payload?.value;
                  if (state.chargeIndex === i) {
                    el.oosItemsComment['isUpdated'] = true;
                  } else {
                    el.oosItemsComment['isUpdated'] = false;
                  }
                  el.oosItemsComment['lastModifiedTimestamp'] = new Date();
                }
              }
              if (action?.payload?.name === 'actualUnits') {
                if (state.chargeIndex === i) {
                  el[action?.payload?.name] = action?.payload?.value;
                }
              }
              if (action?.payload?.name === 'actualAmount') {
                if (state.chargeIndex === i) {
                  el[action?.payload?.name] = action?.payload?.value;
                }
              }
            }
            return el;
          });
        }
        return item;
      });
    },

    handelAddChargeCode: (state, action) => {
      const mydata = JSON.parse(JSON.stringify(state.oosCaseItemsDataToSave));
      state.oosCaseItemsDataToSave = mydata?.map((item, pIndex) => {
        if (state.itemIndex === pIndex) {
          item.chargeCodeList = [...item.chargeCodeList, action.payload];
        }
        return item;
      });
    },

    handleSetDataToSaveHistory: (state, action) => {
      const mydata = JSON.parse(JSON.stringify(state.oosCaseItemsDataToSave));
      state.oosCaseItemsDataToSave = mydata?.map((item, pIndex) => {
        if (state.itemIndex === pIndex) {
          item.chargeCodeList?.map((el, i) => {
            if (el.outScopeFeeId === state?.oosSlectedItemRow?.outScopeFeeId) {
              if (state.chargeIndex === i) {
                el['isUpdated'] = true;
                el['currentStatus'] =
                 action?.payload ?  action?.payload?.addNewHistoryItmeState?.reviewStatus : '';
                const payload = {
                  ...action?.payload?.addNewHistoryItmeState,
                  outScopeFeeId: el?.outScopeFeeId,
                };
                el.oosItemsHistory.unshift(payload);
              }
            }
            return el;
          });
        }
        return item;
      });
    },
    multipleInputWithGridReset: (state) => {
      if (state.oosCasesmultipleInputsValue.accountingGroupCode) {
        state.oosCasesmultipleInputsValue.accountingGroupCode = '';
      }
      if (state.oosCasesmultipleInputsValue.customerName.name) {
        state.oosCasesmultipleInputsValue.customerName.name = '';
      }

      if (state.oosCasesmultipleInputsValue.siteName.name) {
        state.oosCasesmultipleInputsValue.siteName.name = '';
      }

      if (state.oosCasesmultipleInputsValue.reviewStatusId) {
        state.oosCasesmultipleInputsValue.reviewStatusId = 0;
      }

      if (state.oosCasesmultipleInputsValue.caseTypeId) {
        state.oosCasesmultipleInputsValue.caseTypeId = 0;
      }

      if (state.searchResult) {
        state.searchResult = [];
      }
    },
  },
  extraReducers: (builder) => {
    builder

      .addCase(fetchAccountingGroups.pending, (state) => {
        state.isAccountingGroupsResultsFound = false;
        state.accountingGroupModal.accountingGroupGridTotalRecords = 0;
        state.accountingGroupModal.accountingGroupSearchData = [];
        state.loading = true;
        state.loadingAccountingGroup=false;
      })
      .addCase(fetchAccountingGroups.fulfilled, (state, action) => {
        state.loading = false;
        if (action?.payload?.accountingGroups?.length > 0) {
          state.accountingGroupModal.accountingGroups = action?.payload;
          state.accountingGroupModal.accountingGroupSearchData =
            action?.payload?.accountingGroups;
          state.accountingGroupModal.accountingGroupGridTotalRecords =
            action?.payload ? action?.payload?.totalCount : 0;
          state.isAccountingGroupsResultsFound = true;
          state.loadingAccountingGroup=false;
        } else {
          state.accountingGroupModal.accountingGroups = [];
          state.accountingGroupModal.accountingGroupSearchData = [];
          state.accountingGroupModal.accountingGroupGridTotalRecords = 0;
          state.isAccountingGroupsResultsFound = true;
          state.loadingAccountingGroup=false;
        }
      })
      .addCase(fetchAccountingGroups.rejected, (state) => {
        state.accountingGroupModal.accountingGroupSearchData = [];
        state.accountingGroupModal.accountingGroups = [];
        state.accountingGroupModal.accountingGroupGridTotalRecords = 0;
        state.isAccountingGroupsResultsFound = true;
        state.loading = false;
        state.loadingAccountingGroup=false;
      })

      .addCase(getSearchByMultipleInputs.pending, (state) => {
        state.oosCasesLoading = true;
        state.inputError = null;
        state.searchResult = [];
        state.oosCasesTotalRecords = 0;
        state.oosCasesResultsFound = false;
      })
      .addCase(getSearchByMultipleInputs.fulfilled, (state, action) => {
        state.oosCasesLoading = false;
        if (action?.payload) {
          state.searchResult = action?.payload ? action?.payload?.oosCases : [];
          state.oosCasesTotalRecords = action?.payload?.totalRecords
            ? action?.payload?.totalRecords
            : 0;
          state.oosCasesResultsFound = true;
        } else {
          state.searchResult = [];
          state.oosCasesTotalRecords = 0;
          state.oosCasesResultsFound = true;
        }
      })
      .addCase(getSearchByMultipleInputs.rejected, (state, action) => {
        state.oosCasesLoading = false;
        state.inputError = action?.payload;
        state.oosCasesTotalRecords = 0;
        state.oosCasesResultsFound = true;
      })

      .addCase(getHandelSummary.pending, (state) => {
        state.summaryLoading = true;
        state.summaryData = [];
        state.summaryDataFound = false;
      })
      .addCase(getHandelSummary.fulfilled, (state, action) => {
        state.summaryLoading = false;
        state.summaryData = action?.payload
          ? action?.payload?.oosCasesSummary
          : [];
        state.totalNoOosCasesSummary = action?.payload
          ? action?.payload?.totalRecords
          : 0;
        state.summaryDataFound = true;
      })
      .addCase(getHandelSummary.rejected, (state) => {
        state.summaryLoading = false;
        state.summaryData = [];
        state.summaryDataFound = true;
      })

      .addCase(getHandleCaseId.pending, (state) => {
        state.displayError = false;
        state.singleFieldLoader = true;
        state.caseDetails = [];
        state.caseSiteDetails = [];
      })
      .addCase(getHandleCaseId.fulfilled, (state, action) => {
        if (action?.payload) {
          state.caseId = action?.payload ? action?.payload.caseId : 0;
          state.displayError = false;
          state.singleFieldLoader = false;
        } else {
          state.caseId = 0;
          state.displayError = true;
          state.singleFieldLoader = false;
          state.errorModal = action.meta?.arg?.workOrderId
            ? action.meta?.arg?.workOrderId
            : action.meta?.arg?.RMACode
            ? action.meta?.arg?.RMACode
            : 'enterValue';
        }
      })
      .addCase(getHandleCaseId.rejected, (state) => {
        state.caseId = 0;
        state.errorModal = ERROR_MESSAGE.globalError;
        state.displayError = true;
        state.singleFieldLoader = false;
      })

      .addCase(getOosNotes.pending, (state) => {
        state.isNotesDataFound = false;
        state.notesData = [];
      })
      .addCase(getOosNotes.fulfilled, (state, action) => {
        if (action?.payload) {
          state.notesData = action?.payload;
          state.isNotesDataFound = true;
        } else {
          state.notesData = [];
          state.isNotesDataFound = true;
        }
      })
      .addCase(getOosNotes.rejected, (state) => {
        state.isNotesDataFound = true;
        state.notesData = [];
      })

      .addCase(getHandleCaseDetails.pending, (state) => {
        state.caseDetailsLoading = true;
        state.caseDetails = [];
      })
      .addCase(getHandleCaseDetails.fulfilled, (state, action) => {
        if (action?.payload) {
          state.caseDetails = action?.payload;
          state.caseDetailsLoading = false;
        } else {
          state.caseDetails = [];
          state.caseDetailsLoading = false;
        }
      })
      .addCase(getHandleCaseDetails.rejected, (state) => {
        state.caseDetailsLoading = false;
        state.caseDetails = [];
      })

      .addCase(getHandleCaseSiteDetails.pending, (state) => {
        state.caseDetailsLoading = true;
        state.singleFieldLoader = true;
        state.caseSiteDetails = [];
        state.displayError = false;
        state.errorModal = initialState.errorModal;
        state.fastFindData = false;
      })
      .addCase(getHandleCaseSiteDetails.fulfilled, (state, action) => {
        if (action?.payload) {
          state.caseSiteDetails = action?.payload;
          state.caseId = action?.meta?.arg;
          state.caseDetailsLoading = false;
          state.singleFieldLoader = false;
          state.displayError = false;
        } else {
          state.caseSiteDetails = [];
          state.caseDetailsLoading = false;
          state.displayError = true;
          state.singleFieldLoader = false;
          state.errorModal = action.meta?.arg
            ? action.meta?.arg
            : ERROR_MESSAGE.globalError;
        }
      })
      .addCase(getHandleCaseSiteDetails.rejected, (state, action) => {
        state.caseDetailsLoading = false;
        state.singleFieldLoader = false;
        state.caseSiteDetails = [];
        state.displayError = true;
        state.errorModal = action.meta?.arg
          ? action.meta?.arg
          : ERROR_MESSAGE.globalError;
      })

      .addCase(getHandleOOSCaseItems.pending, (state) => {
        state.caseItemsLoading = true;
        state.oosCaseItems = [];
        state.oosCaseItemsDataToSave = [];
      })
      .addCase(getHandleOOSCaseItems.fulfilled, (state, action) => {
        if (action?.payload) {
          state.oosCaseItems = action?.payload;
          state.oosCaseItemsDataToSave = action?.payload;
          state.oosCaseItemsDataToSave?.map((item) => {
            item.chargeCodeList?.map((el) => {
              el['billRuleId'] = null;
              el['isInserted'] = false;
              el['isUpdated'] = false;
              el['swCaseId'] = Number(state.caseId);
              return el;
            });
            return item;
          });
          state.caseItemsLoading = false;
        } else {
          state.oosCaseItems = [];
          state.oosCaseItemsDataToSave = [];
          state.caseItemsLoading = false;
        }
      })
      .addCase(getHandleOOSCaseItems.rejected, (state) => {
        state.caseItemsLoading = false;
        state.oosCaseItems = [];
        state.oosCaseItemsDataToSave = [];
      })

      .addCase(getHandleOOSCaseItemHistory.pending, (state) => {
        state.caseItemHistoryLoading = true;
      })
      .addCase(getHandleOOSCaseItemHistory.fulfilled, (state, action) => {
        let myHistory = action?.payload
          ? action?.payload.oosCasesItemHistory
          : [];
        if (action?.payload) {
          state.oosCaseItemsDataToSave?.map((item) => {
            item.chargeCodeList?.map((el) => {
              if (
                el?.outScopeFeeId === state.oosSlectedItemRow?.outScopeFeeId &&
                !el?.oosItemsHistory
              ) {
                el['oosItemsHistory'] = myHistory.map((item) => {
                  item['isInserted'] = false;
                  return item;
                });
              }
              return el;
            });
            return item;
          });
          state.caseItemHistoryLoading = false;
        } else {
          state.caseItemHistoryLoading = false;
        }
      })
      .addCase(getHandleOOSCaseItemHistory.rejected, (state) => {
        state.caseItemHistoryLoading = false;
      })

      .addCase(getHandleOOSCaseItemComment.pending, (state) => {
        state.caseItemCommentLoading = true;
      })
      .addCase(getHandleOOSCaseItemComment.fulfilled, (state, action) => {
        if (action?.payload) {
          state.oosCaseItemComment = action?.payload;
          state.oosCaseItemsDataToSave?.map((item) => {
            item.chargeCodeList?.map((el) => {
              if (
                el?.outScopeId === state.oosSlectedItemRow?.outScopeId &&
                el?.swCaseId === state.oosSlectedItemRow?.swCaseId &&
                !el?.oosItemsComment
              ) {
                state.oosSlectedItemRow['oosItemsComment'] = action?.payload;
                state.oosSlectedItemRow['oosItemsComment'].caseId = Number(
                  state.caseId
                );
                state.oosSlectedItemRow['oosItemsComment'].outScopeId =
                  el?.outScopeId;
                el['oosItemsComment'] = action?.payload
                  ? action?.payload
                  : { comment: '' };
                el['oosItemsComment'].caseId = Number(state.caseId);
                el['oosItemsComment'].outScopeId = el?.outScopeId;
              }
              return el;
            });
            return item;
          });
          state.caseItemCommentLoading = false;
        } else {
          state.oosCaseItemComment = [];
          state.oosCaseItemsDataToSave?.map((item) => {
            item.chargeCodeList?.map((el) => {
              if (
                el?.outScopeId === state.oosSlectedItemRow?.outScopeId &&
                el?.swCaseId === state.oosSlectedItemRow?.swCaseId &&
                !el?.oosItemsComment
              ) {
                el['oosItemsComment'] = action?.payload
                  ? action?.payload
                  : { comment: '' };
                el['oosItemsComment'].caseId = Number(state.caseId);
                el['oosItemsComment'].outScopeId = el?.outScopeId;
              }
              return el;
            });
            return item;
          });
          state.caseItemCommentLoading = false;
        }
      })
      .addCase(getHandleOOSCaseItemComment.rejected, (state) => {
        state.caseItemCommentLoading = false;
        state.oosCaseItemComment = [];
      })

      .addCase(getHandleOOSCaseItemRMA.pending, (state) => {
        state.caseItemRMALoading = true;
        state.oosCaseItemRMA = [];
      })
      .addCase(getHandleOOSCaseItemRMA.fulfilled, (state, action) => {
        if (action?.payload) {
          state.oosCaseItemRMA = action?.payload;
          state.caseItemRMALoading = false;
        } else {
          state.oosCaseItemRMA = [];
          state.caseItemRMALoading = false;
        }
      })
      .addCase(getHandleOOSCaseItemRMA.rejected, (state) => {
        state.caseItemRMALoading = false;
        state.oosCaseItemRMA = [];
      })

      .addCase(saveHandleOOSCaseItems.pending, (state) => {
        state.saveLoading = true;
        state.saveMessage = null;
      })
      .addCase(saveHandleOOSCaseItems.fulfilled, (state, action) => {
        if (action?.payload) {
          state.saveMessage = action?.payload;
          state.saveLoading = false;
        } else {
          state.saveMessage = false;
          state.saveLoading = false;
        }
      })
      .addCase(saveHandleOOSCaseItems.rejected, (state) => {
        state.saveLoading = false;
        state.saveMessage = false;
      });
  },
});

export const {
  setSelectedTabValue,
  setSelectedComponent,
  resetValues,
  setSelectedAccountGridRowsData,
  setAccountingGroupModalOpen,
  setAccountingGroupModalClose,
  setAccouningGroupFormFeilds,
  setSaveMultipleValues,
  setSaveSingleFieldSearch,
  setHandleCaseId,
  setHandleDisplayError,
  formResetValues,
  setFastFind,
  resetBackValues,
  handleSetChargeCode,
  handleSelectedOOSItemRow,
  handleSetDataToSave,
  handelSetClickedIndex,
  handelAddChargeCode,
  handleSetDataToSaveHistory,
  multipleInputWithGridReset,
} = CustomersSearchSlice.actions;
export default CustomersSearchSlice.reducer;
